import React from 'react'
import { useSiteContent, sectionField } from '../../hooks/useSiteContent'
import { toGoogleMapsEmbed, ISLAMABAD_MAP_EMBED } from '../../utils/mapsEmbed'

function ContactMap() {
    const { content } = useSiteContent('contact')
    const embed = toGoogleMapsEmbed(
        sectionField(content, 'map', 'embed_url', ''),
        ISLAMABAD_MAP_EMBED
    )

    return (
        <div className="">
            <div className="container-fluid">
                <div className="contact-map style2">
                    <iframe
                        title="Office location"
                        src={embed}
                        width="100%"
                        height="450"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                    <div className="contact-icon">
                        <img src="/assets/img/icon/location-dot3.svg" alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactMap
